import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Affordablecabserviceinumbai() {



const cardData = {
  keyword: " Affordable Cab Service in Mumbai ",

headingDescription: "Velocity Cab provides affordable cab service in Mumbai, offering cost‑effective and reliable taxi options for local travel, airport transfers, outstation trips, and corporate rides. We focus on transparent pricing with no hidden charges and comfortable travel for individuals, families, and groups. Our fleet of well‑maintained air‑conditioned sedans, hatchbacks, and SUVs combined with professional drivers ensures punctual pickups and smooth journeys across Mumbai and surrounding areas. With easy online booking, flexible ride options, and 24/7 customer support, Velocity Cab is the trusted and budget‑friendly choice for affordable cab services in Mumbai.",

topPlaces: [

  {
    title: "Alibaug",
    description: "Alibaug is a beautiful coastal getaway near Mumbai famous for its clean beaches, sea forts, and relaxed vibe. Visitors can enjoy Alibaug Beach, Kolaba Fort, and Mandwa Jetty while experiencing a peaceful seaside escape perfect for weekend trips."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a serene hill station located in the Western Ghats, known for its lush greenery, waterfalls, and calm environment. It is ideal for meditation retreats, nature walks, and scenic drives through fog-covered mountains."
  },
  {
    title: "Matheran",
    description: "Matheran is India’s smallest hill station and a unique eco-friendly destination near Mumbai. Known for its vehicle-free environment, visitors can explore viewpoints like Panorama Point and Echo Point while enjoying horse rides and walking trails."
  },
    {
    title: "Lonavala",
    description: "Lonavala is one of the most popular outstation destinations from Mumbai, known for its lush green valleys, misty hills, and scenic waterfalls. Travelers booking a sedan cab can enjoy a comfortable drive via the Mumbai–Pune Expressway and visit attractions like Tiger Point, Bhushi Dam, and Lion’s Point for breathtaking views."
  },
  {
    title: "Nashik",
    description: "Nashik is a major pilgrimage and wine tourism destination near Mumbai, famous for the Trimbakeshwar Temple and Sula Vineyards. Travelers can enjoy spiritual visits, vineyard tours, and scenic riverfront experiences along the Godavari River."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India’s most important pilgrimage sites dedicated to Sai Baba. Visitors can visit the Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi while experiencing a peaceful spiritual atmosphere."
  },
  {
    title: "Saputara",
    description: "Saputara is a picturesque hill station in Gujarat near the Maharashtra border, known for its cool climate, lakes, and viewpoints. It offers boating, ropeway rides, and scenic sunset spots ideal for family trips."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a charming hill station near Mumbai famous for its strawberry farms, Table Land plateau, and scenic valley views. It is perfect for relaxing holidays and nature photography."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for its cool weather, strawberry farms, and viewpoints like Arthur’s Seat and Elephant’s Head Point. It is ideal for long weekend getaways from Mumbai."
  },
  {
    title: "Kashid Beach",
    description: "Kashid Beach is a peaceful coastal destination near Mumbai known for its white sand, clear waters, and water sports activities. It is a great spot for relaxation, camping, and seaside drives."
  }
],



services: [
{
name: "Affordable Taxi Service Mumbai",
description: "Affordable taxi service Mumbai offers cost-effective and reliable transportation for daily travel, airport transfers, and outstation journeys. This service is ideal for individuals, families, and corporate travelers looking for budget-friendly cab options without compromising on comfort. Well-maintained vehicles and experienced drivers ensure a smooth and safe journey across Mumbai. Transparent pricing with no hidden charges makes travel planning easy. Flexible booking options allow instant or scheduled rides as per customer needs. It is a perfect choice for economical and dependable cab services in Mumbai."
},
{
name: "Budget Cab Service Mumbai",
description: "Budget cab service Mumbai provides economical travel solutions for customers who want affordable rides across the city and beyond. This service is designed to deliver comfort and safety at competitive prices. Customers can choose from a range of vehicles including hatchbacks, sedans, and SUVs. Professional drivers ensure timely pickups and smooth travel experiences. Transparent billing ensures clarity in fares. It is suitable for both personal and business travel. It ensures reliable and cost-effective transportation."
},
{
name: "Cheap Taxi Mumbai",
description: "Cheap taxi Mumbai offers low-cost transportation options for daily commuting, airport transfers, and long-distance travel. This service is ideal for budget-conscious travelers who want comfortable rides at minimal prices. Vehicles are clean and well-maintained to ensure a pleasant journey. Professional drivers ensure safe and timely service. Flexible booking options make it convenient for users. Transparent pricing avoids hidden charges. It is one of the best options for affordable travel in Mumbai."
},
{
name: "Low Cost Cab Mumbai",
description: "Low cost cab Mumbai provides economical travel options for customers seeking budget-friendly transportation. This service is perfect for daily commuters, students, and frequent travelers. Vehicles are maintained for safety and comfort during city and highway travel. Professional drivers ensure smooth and reliable service. Flexible booking options allow easy travel planning. Transparent pricing ensures no surprises in billing. It is ideal for low-cost and convenient travel in Mumbai."
},
{
name: "Best Affordable Cab Mumbai",
description: "Best affordable cab Mumbai combines cost-effectiveness with quality service to deliver a comfortable travel experience. This service is suitable for customers who want reliable transportation at reasonable prices. Vehicles are well-maintained and equipped for safe journeys. Experienced drivers ensure timely pickups and efficient routes. Transparent pricing ensures complete clarity in fares. It is widely preferred for budget-friendly travel. It offers the best balance between price and comfort."
},
{
name: "Budget Airport Cab Mumbai",
description: "Budget airport cab Mumbai offers affordable airport pickup and drop services with reliable and timely transportation. This service is ideal for travelers looking for economical airport transfers. Drivers monitor flight schedules to ensure punctual pickups and drops. Clean and comfortable vehicles enhance the travel experience. Flexible booking options allow easy reservations. Transparent pricing ensures no hidden charges. It ensures a smooth and stress-free airport journey at a budget-friendly price."
},
{
name: "Affordable Outstation Cab Mumbai",
description: "Affordable outstation cab Mumbai provides cost-effective travel solutions for long-distance journeys to destinations like Pune, Nashik, Shirdi, Lonavala, and Goa. This service is ideal for travelers seeking economical intercity transportation. Vehicles are well-maintained for highway travel ensuring comfort and safety. Flexible options include one way and round trip bookings. Professional drivers ensure smooth and timely journeys. Transparent pricing helps customers manage travel budgets easily. It is a great choice for affordable outstation travel."
},
{
name: "Economy Cab Booking Mumbai",
description: "Economy cab booking Mumbai offers budget-friendly transportation options for both city rides and outstation travel. This service is perfect for travelers who want reliable rides at affordable rates. Vehicles are clean and well-maintained to ensure comfort. Professional drivers ensure safe and punctual service. Easy booking options make it convenient for customers. Transparent pricing ensures no hidden costs. It is widely preferred for economical travel solutions."
},
{
name: "Low Fare Taxi Booking Mumbai",
description: "Low fare taxi booking Mumbai provides economical cab booking options for daily commuting, airport transfers, and outstation trips. This service is designed for customers looking for reliable transportation at minimal fares. Vehicles are maintained for safety and comfort. Professional drivers ensure smooth and timely journeys. Flexible booking options add convenience for users. Transparent pricing ensures no extra charges. It is an ideal solution for affordable and hassle-free travel in Mumbai."
}
],

tableData: [
["Affordable Taxi Service Mumbai","Budget Cab Service Mumbai"],
["Cheap Taxi Mumbai","Low Cost Cab Mumbai"],
["Best Affordable Cab Mumbai","Budget Airport Cab Mumbai"],
["Affordable Outstation Cab Mumbai","Economy Cab Booking Mumbai"],
["Low Fare Taxi Booking Mumbai","Cheap Taxi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Affordable & Value for Money Pricing",
    WhyChoosedescription: "Velocity Cabs offers affordable cab service in Mumbai with competitive pricing, making it ideal for daily travel, airport transfers, and outstation trips without compromising on quality."
  },
  {
    WhyChooseheading: "Transparent Fare Structure",
    WhyChoosedescription: "We provide complete fare transparency with clear pricing details including per km charges, tolls, and driver allowance, ensuring no hidden costs for customers."
  },
  {
    WhyChooseheading: "Budget-Friendly Travel Options",
    WhyChoosedescription: "Velocity Cabs provides cost-effective travel solutions with flexible packages suitable for individuals, families, and corporate travelers looking for economical cab services in Mumbai."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our affordable cab service in Mumbai operates 24/7, allowing customers to book rides anytime for local travel, airport pickup, or outstation journeys."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable travel experience at budget-friendly prices."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers hatchbacks, sedan cars, SUVs like Ertiga and Innova, and premium vehicles, allowing customers to choose according to their budget and travel needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and airports across Mumbai for hassle-free travel."
  },
  {
    WhyChooseheading: "Trusted Affordable Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for affordable cab service in Mumbai due to reliable drivers, reasonable pricing, and consistent service quality."
  }
]
};

const faqData = [
  { question: "Do you provide affordable cab service in Mumbai?", answer: "Yes, Velocity Cabs provides affordable cab services in Mumbai for local, airport, and outstation travel." },
  { question: "What is the price of affordable cabs in Mumbai?", answer: "Cab fares typically start from ₹10 to ₹18 per km depending on vehicle type and travel requirements." },
  { question: "Which is the most affordable cab option?", answer: "Hatchback and sedan cars are the most economical options for budget travel in Mumbai." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for customer convenience." },
  { question: "Can I book affordable cab for airport transfer?", answer: "Yes, we provide budget-friendly airport pickup and drop services in Mumbai." },
  { question: "Are affordable cabs safe?", answer: "Yes, all our drivers are verified and vehicles are well maintained to ensure safe travel." },
  { question: "Can I book cab online?", answer: "Yes, customers can easily book affordable cab service in Mumbai online or through phone booking." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we offer both one-way and round-trip cab options." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended to get the best pricing and availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Nair",
    feedback:
      "Finding an affordable cab service in Mumbai was easy with Velocity Cabs. The fare was reasonable, the driver was friendly, and the entire trip was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Verma",
    feedback:
      "Velocity Cabs offers one of the most affordable cab services in Mumbai without compromising on quality. The cab was clean, the driver was punctual, and the overall experience exceeded my expectations.",
    rating: 5
  }
];




















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const affordableCabMumbaiJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Affordable Cab Service in Mumbai | Velocity Cabs",
  "description": "Book an affordable cab service in Mumbai for city trips, airport transfers, or outstation travel. AC, Sedan, and SUV taxis available at low fares for one-way or round trips.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Affordable Cab Packages in Mumbai",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "Affordable One Way Cab in Mumbai",
        "description": "Low-cost one-way cab service in Mumbai with AC, SUV, or Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Affordable Cab in Mumbai",
        "description": "Budget-friendly round-trip cab service in Mumbai with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};



  return (
    <div>
      

<Helmet>
  <title>Affordable Cab Service in Mumbai | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book an affordable cab service in Mumbai for city trips, airport transfers, or outstation travel. AC, Sedan, and SUV taxis available at low fares for one-way or round trips."
  />
  <script type="application/ld+json">
    {JSON.stringify(affordableCabMumbaiJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/112.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Affordablecabserviceinumbai;